import primaryButton from '../../../../primary-button';

const custom = (params) => primaryButton.solidIcon.background.active.custom(params);

export default custom;
